import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";

const tabs = [
  { label: "Upcoming meetings", url: "/upcoming" },
  { label: "Current meetings", url: "/current" },
  { label: "Recorded meetings", url: "/recorded" },
];

export class StudyGroupUserWebinars extends Component {
  render() {
    const {
      params: { id },
      location,
    } = this.props;

    return (
      <div>
        <NavigationButtons
          pathname={location.pathname}
          tabs={tabs}
          groupId={id}
        />
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserWebinars);

class NavigationButtons extends Component {
  render() {
    const { tabs, groupId, pathname } = this.props;

    const getUrl = (url) => `/groups/${groupId}/webinars${url}`;

    const isActive = (url) => pathname.includes(url);

    return (
      <div className="group-navigation-webinar">
        {tabs.map(({ label, url }, idx) => {
          const [first, last] = label.split(" ");

          return (
            <Link
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`group-webinar-button ${
                isActive(url) ? "active" : ""
              }`}
              to={getUrl(url)}
              key={idx}
            >
              <div>{first}</div>
              <div>{last}</div>
            </Link>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserWebinars/index.jsx